import { LoadingStateMdl } from "shared/_common/loaders/_models/LoadingStateMdl";
import { useState } from "react";
import { createLoadingStateFromPromise } from "shared/_common/loaders/loadingStateUtils";

export function useLoadingFromPromise<TValue>(promise?: Promise<TValue>) {
    const [loading, setLoading] = useState<LoadingStateMdl<TValue> | undefined>(
        promise ? createLoadingStateFromPromise(promise) : undefined,
    );
    return {
        loading,
        setPromise: (promise: Promise<TValue>) => setLoading(createLoadingStateFromPromise(promise)),
    };
}
